{
  "info": "מידע",
  "negative": "שגיאה",
  "positive": "הצלחה"
}
